import { render, staticRenderFns } from "./LinkedStockNo.vue?vue&type=template&id=5bb0cae5&scoped=true"
import script from "./LinkedStockNo.vue?vue&type=script&lang=js"
export * from "./LinkedStockNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0cae5",
  null
  
)

export default component.exports